import { User } from './user'
import { RegionFormParams } from './region'
import { Polygon, PointCoordinates } from 'models/map'

export enum AreaType {
  'ISOCHRONE_WALK' = 'ISOCHRONE_WALK',
  'ISOCHRONE_WALK_NO_TRAFFIC' = 'ISOCHRONE_WALK_NO_TRAFFIC',
  'ISOCHRONE_CAR' = 'ISOCHRONE_CAR',
  'ISOCHRONE_CAR_NO_TRAFFIC' = 'ISOCHRONE_CAR_NO_TRAFFIC',
  'ISOCHRONE_BIKE' = 'ISOCHRONE_BIKE',
  'ISOCHRONE_BIKE_NO_TRAFFIC' = 'ISOCHRONE_BIKE_NO_TRAFFIC',
  'ISOCHRONE_PUBLICTRANSPORT' = 'ISOCHRONE_PUBLICTRANSPORT',
  'ISOCHRONE_PUBLICTRANSPORT_NO_TRAFFIC' = 'ISOCHRONE_PUBLICTRANSPORT_NO_TRAFFIC',
  'POLYGON' = 'POLYGON',
  'FILE' = 'FILE',
  'REGION' = 'REGION',
  'RADIUS' = 'RADIUS',
}
//Llamar a la api para ver si trae el punto del proyecto
export type Project = {
  id: string
  name: string
  areaType: AreaType
  areaMeasure: string
  time?: number
  radius?: number
  city: string
  municipality: string
  state: string
  country: string
  imageUrl: string
  createdAt: string
  updatedAt: string
  activeLayers: number[]
  hiddenLayers: number[]
  filters: any
  areas: Area[]
  geometry: any
  owner: User
  customReportId?: number
  centroid: any
  reporttype: number
  reporturls?: string[]
}

export type ProjectTableFilters = {
  offset: number
  limit: number
  sortBy: string
  q: string
}

export type ProjectsResponse = {
  totalItems: number
  projects: Project[]
}

export type CreateProjectParams = {
  name?: string
  areaType: AreaType
  activeLayers?: number[]
  hiddenLayers?: number[]
  filters?: {}

  // Isochrone
  coordinates?: PointCoordinates
  time?: number
  radius?: number

  // Polygon
  geometry?: Polygon

  // File
  file?: File

  // Region
  region?: RegionFormParams
}

export type Area = {
  id: number
  name: string
  areaType: AreaType
  color: string
  geometry?: any
  centroid?: any
}

export type CreateAreaParams = {
  name: string
  color: string
  areaType: AreaType

  // Isochrone
  coordinates?: PointCoordinates
  time?: number
  radius?: number

  // Polygon
  geometry?: Polygon & {
    crs: {
      type: string
      properties: any
    }
  }

  // File
  file?: File

  // Region
  region?: RegionFormParams
}
